var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('header',{staticClass:"app__header"},[_c('Header')],1),_c('div',{staticClass:"app__loader"},[_c('Loader')],1),_c('div',{staticClass:"app__alert"},[_c('Alert')],1),_c('main',{staticClass:"app__main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }